<div class="div-arriere-plan-action"></div>
<div class="div-global-action">
  <h1>{{title}}</h1>
  <p>{{description}}</p>
</div>
